// Separate request orchestration from the browser widget so failure paths can
// be tested without a real account or any business API calls.
export function createHumanRequest ({ config, challenge, send, context = () => '', subscribeNavigation = () => () => {}, captureReset = () => () => {} }) {
  let busy = false
  return async function protectedRequest (url, action, data, beforeSend = () => {}) {
    if (busy) throw new Error('正在验证或提交，请勿重复操作')
    busy = true
    // Snapshot before asynchronous verification, do not mutate the live form.
    const payload = { ...data }
    let unsubscribe = () => {}
    let reset = () => {}
    let navigated = false
    try {
      reset = captureReset(action)
      const originalContext = context()
      // Remember the event, even when navigation returns to the original URL.
      unsubscribe = subscribeNavigation(() => { navigated = true })
      const result = await config()
      if (navigated || context() !== originalContext) throw new Error('页面已切换，请重新验证')
      if (!result || typeof result.enabled !== 'boolean') throw new Error('安全验证配置不可用')
      if (result.enabled) {
        if (!result.sitekey) throw new Error('安全验证配置不可用')
        const token = await challenge(result.sitekey, action)
        if (navigated || context() !== originalContext) throw new Error('页面已切换，请重新验证')
        if (!token) throw new Error('请完成人机验证')
        payload['cf-turnstile-response'] = token
      }
      beforeSend()
      return await send(url, payload)
    } finally {
      unsubscribe()
      busy = false
      reset()
    }
  }
}
